// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
//
const viewPortHeight = () => {
  // Workaround since phone browsers includes areas hidden behind the address
  // bar etc in the css vh unit calculation
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export const addResizeListener = () => {
  viewPortHeight()
  window.addEventListener('resize', viewPortHeight)
  return () => window.removeEventListener('resize', viewPortHeight)
}

export const scrollParent = node => {
  // find parent scroll element
  if (node.scrollHeight === node.clientHeight && node.parentElement)
    return scrollParent(node.parentElement)
  return node
}
